/* @flow */
import _ from 'lodash';

import Entity from 'lib/Entity';
import Group from 'entities/Group';
import OfficeHours from 'entities/OfficeHours';
import PublicDevice from 'entities/PublicDevice';
import Subscription from 'entities/Subscription';
import Subscriptions from 'collections/Subscriptions';

// The user in a GroupMembership (Group <-> User relationship)
// This is the same as User, and has the same id, but only a subset of the properties of a User
class Subscriber extends Entity {
  urlRoot() {
    return '/subscribers';
  }

  parse(response: Object) {
    const subscriber = _.clone(response);
    if (subscriber['devices']) {
      subscriber['devices'] = subscriber['devices'].map(device => {
        return PublicDevice.fromJSON(device);
      });
    }
    if (subscriber['subscriptions']) {
      subscriber['subscriptions'] = Subscriptions.fromJSON(subscriber['subscriptions']);
    }
    if (subscriber['subscribed_at']) {
      subscriber['subscribed_at'] = new Date(subscriber['subscribed_at']);
    }
    if (subscriber['office_hours']) {
      subscriber['office_hours'] = OfficeHours.fromJSON(subscriber['office_hours']);
    }
    return subscriber;
  }

  getName() {
    return this.get('name');
  }

  getNote() {
    return this.get('note');
  }

  getRole() {
    return this.get('role');
  }

  getFirstName() {
    return this.get('first_name') || '';
  }

  getLastName() {
    return this.get('last_name') || '';
  }

  getFullName() {
    return `${this.getFirstName()} ${this.getLastName()}`;
  }

  getSignature() {
    return this.get('signature');
  }

  getOfficeHours() {
    return this.get('office_hours');
  }

  getSubscribedAt() {
    return this.get('subscribed_at');
  }

  getMediums() {
    return this.get('mediums');
  }

  getDevices() {
    return this.get('devices');
  }

  isNotable() {
    return this.get('notable');
  }

  isBlocked() {
    return this.get('blocked');
  }

  getUntrustedName() {
    return this.get('untrusted_name');
  }

  getColor() {
    return this.get('color');
  }

  getInitials() {
    return this.get('initials');
  }

  isCurrentUser() {
    // XXX remove CurrentUser from entities
    const CurrentUser = require('auth/CurrentUser').default;
    return this.id === CurrentUser.getUser().id;
  }

  setNote(note: string) {
    return this.set({ note });
  }

  setFirstName(firstName: string) {
    return this.set({ first_name: firstName });
  }

  setLastName(lastName: string) {
    return this.set({ last_name: lastName });
  }

  getSubscriptions() {
    return this.get('subscriptions');
  }

  getCanBeCopiedToClass() {
    return this.get('can_be_copied_to_class');
  }

  subscribe(subscription: Subscription) {
    this.get('subscriptions').add(subscription);
  }

  unsubscribeFromGroup(group: Group) {
    const subscriptions = this.getSubscriptions();
    subscriptions.filter(s => s.getGroupId() === group.id).forEach(sub => {
      subscriptions.remove(sub.id);
    });
  }

  confirmUntrustedName() {
    return this.set({ untrusted_name: false });
  }

  toJSON() {
    const json = super.toJSON();
    if (json['subscriptions']) {
      json['subscriptions'] = this.get('subscriptions').toJSON();
    }
    return json;
  }
}

export default Subscriber;



// WEBPACK FOOTER //
// ./src/entities/Subscriber.js